import { ReactNode } from 'react'

import { COUNTER_STYLE, ExtractStrongNodeSpecAttributes, nodes } from 'prose-core'

import { ReactComponent as UpperLatinFormatIcon } from './upperLatinFormat.svg'
import { ReactComponent as DecimalFormatIcon } from './decimalFormat.svg'
import { ReactComponent as DecimalLetterNonFlattenedFormatIcon } from './decimalLetterNonFlattenedFormat.svg'
import { ReactComponent as DecimalNonFlattenedFormatIcon } from './decimalNonFlattenedFormat.svg'
import { ReactComponent as DecimalParenthesesFormatIcon } from './decimalParenthesesFormat.svg'
import { ReactComponent as UpperRomanFormatIcon } from './upperRomanFormat.svg'

export type NumberedListFormat =
  | 'decimal'
  | 'decimalParentheses'
  | 'decimalNonFlattened'
  | 'upperLatin'
  | 'upperRoman'
  | 'decimalLetterNonFlattened'

export const FORMAT_OPTIONS: Record<
  NumberedListFormat,
  {
    attrs: Partial<ExtractStrongNodeSpecAttributes<typeof nodes.ordered_list>>
    icon: ReactNode
    textValue: string
  }
> = {
  decimal: {
    attrs: {
      counterSeparator: '.',
      counterStyles: [COUNTER_STYLE.DECIMAL, COUNTER_STYLE.LOWER_ALPHA, COUNTER_STYLE.LOWER_ROMAN],
      flattenMarker: true,
    },
    icon: <DecimalFormatIcon />,
    textValue: 'Decimal with dot as separator',
  },
  decimalParentheses: {
    attrs: {
      counterSeparator: ')',
      counterStyles: [COUNTER_STYLE.DECIMAL, COUNTER_STYLE.LOWER_ALPHA, COUNTER_STYLE.LOWER_ROMAN],
      flattenMarker: true,
    },
    icon: <DecimalParenthesesFormatIcon />,
    textValue: 'Decimal with parenthesis as separator',
  },
  decimalNonFlattened: {
    attrs: {
      counterSeparator: '.',
      counterStyles: [COUNTER_STYLE.DECIMAL],
      flattenMarker: false,
    },
    icon: <DecimalNonFlattenedFormatIcon />,
    textValue: 'Decimal with repeated counter and dots as separators',
  },
  upperLatin: {
    attrs: {
      counterSeparator: '.',
      counterStyles: [COUNTER_STYLE.UPPER_LATIN, COUNTER_STYLE.LOWER_ALPHA, COUNTER_STYLE.LOWER_ROMAN],
      flattenMarker: true,
    },
    icon: <UpperLatinFormatIcon />,
    textValue: 'Uppercase latin letters with dot as separator',
  },
  upperRoman: {
    attrs: {
      counterSeparator: '.',
      counterStyles: [COUNTER_STYLE.UPPER_ROMAN, COUNTER_STYLE.UPPER_LATIN, COUNTER_STYLE.DECIMAL],
      flattenMarker: true,
    },
    icon: <UpperRomanFormatIcon />,
    textValue: 'Uppercase roman letters with dot as separator',
  },
  decimalLetterNonFlattened: {
    attrs: {
      counterSeparator: '.',
      counterStyles: [COUNTER_STYLE.DECIMAL, COUNTER_STYLE.LOWER_ALPHA, COUNTER_STYLE.LOWER_ROMAN],
      flattenMarker: false,
    },
    icon: <DecimalLetterNonFlattenedFormatIcon />,
    textValue: 'Decimal, followed by letters with repeated counter and dots as separators',
  },
}
